// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_mg-1";
export var rowFirst = "_mg-3";
export var rowLast = "_mg-5";
export var rowMiddle = "_mg-4";
export var ticketListScroll = "_mg-2";
export var ticketStack = "_mg-0";